import xlsx from "xlsx";
import { saveAs } from "file-saver";

export const exportToExcel = (data, fileName) => {
  const worksheet = xlsx.utils.json_to_sheet(data);
  const workbook = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  // Generate buffer
  const buffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
  // Save file
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    `${fileName}.xlsx`
  );
};
